<template>
    <div v-if="$store.getters['CheckAction']('Read', undefined, Action)">
        <!-- Etape 1 -->
        <ShareChoice v-if="shareMode === shareModeEnum.Choice" :Variant="Variant" :Visible="shareMode == shareModeEnum.Choice" :ShareType.sync="shareType" :Title.sync="shareLabel" @ShareTypeEndedEvent="shareMode = shareModeEnum.Component;" @CancelEvent="visible = false;" />

        <!-- Etape 2 -->
        <ShareComponent v-if="shareMode === shareModeEnum.Component" :Variant="Variant" :Visible="shareMode === shareModeEnum.Component" :ShareType.sync="shareType" :Title="shareLabel" :ShareIds.sync="shareIds" @ShowUsersEvent="shareMode = shareModeEnum.Users" @CancelEvent="shareMode = shareModeEnum.Choice;" @CloseEvent="visible = false;" />

        <!-- Etape 3 -->
        <ShareUsers v-if="shareMode === shareModeEnum.Users" :Variant="Variant" :Visible="shareMode === shareModeEnum.Users" :UserIds.sync="userIds" :ForcedShare.sync="forcedShare" @CancelEvent="shareMode = shareModeEnum.Component" @SendShareEvent="sendShare()" @CloseEvent="visible = false;" />
    </div>
</template>

<script lang="ts">
    import { Component, Prop, PropSync, ProvideReactive, Vue } from 'vue-property-decorator';
    import ShareComponent from './Share/ShareComponent.vue';
    import ShareChoice from './Share/ShareChoice.vue';
    import ShareUsers from './Share/ShareUsers.vue';
    import Dictionary from '@/types/Dictionary';
    import locales from './locales/Share.json';

    /** Composant permettant la sélection des différents composants à partager (filtres, masques, tableau de bord, ...) */
    @Component({
        components: {
            ShareComponent,
            ShareChoice,
            ShareUsers
        },
        i18n: { messages: locales }
    })
    export default class Share extends Vue {
        private shareModeEnum = ShareModeEnum;
        private shareMode : ShareModeEnum = ShareModeEnum.None;

        @PropSync('Visible')
        public visible!: boolean;

        @Prop({ default: () => "secondary"})
		public Variant!: string;

        /** Droit disponible pour l'utilisateur en cours */
        @Prop()
        @ProvideReactive()
        public Action!: string;

        /** Type d'éléments partagé */
        private shareType : string = "";

        private shareLabel : string = "";

        /** Elements sélectionnés à partager */
        private shareIds : string[] = [];

        /** Utilisateurs sélectionnés pour le partage */
        private userIds : Dictionary<any> = {};

        // indique que l'on veut forcer le partage
        forcedShare: boolean = false;            

        /**
         * permet de réaliser le partage d'éléments selon un type et les identifiants des élements et des utilisateurs
         */
        private async sendShare() {
            // On vérifie que l'utilisateur a bien les droits de partage
            if (!this.$store.getters["CheckAction"]("Write", undefined, this.Action)) {
                console.error("Share - sendShare() - Droits insuffisants, CheckAction = ", this.$store.getters["CheckAction"]("Write", undefined, this.Action));
                return;
            }

            // Ecran de chargement
            this.$store.dispatch("ShowLoadingMask", this.$t('ShareInProgress').toString());

            await this.$store.dispatch("Share", { shareType: this.shareType, shareIds : this.shareIds, userIds : this.userIds, forcedShare : this.forcedShare}).then(() => {
                this.$store.dispatch("HideLoadingMask", {}).then(() =>{
                    // Affiche un toast pour indiquer que le partage a été réalisé
                    this.$bvToast.toast(this.$t('SelectedElementsShared').toString(), { // "Les éléments sélectionnés ont été partagé avec succès."
                            title: this.$t('SharingElements').toString(),
                            autoHideDelay: 2000,
                            variant: "success",
                            solid: true,
                            appendToast: true,
                            toaster: "b-toaster-top-center"
                    });

                    // Si on a partagé en mode forcé, il recharger les tableaux de bord ?
                    if(this.forcedShare)
                        this.$store.dispatch("MainDashboardStore/LoadData");

                }); 
            }).catch(err => {
					console.error(err);
                    this.$store.dispatch("HideLoadingMask", {}).then(() =>{
                        this.$bvToast.toast(this.$t('ShareErrorOccured').toString(), {
                            title: this.$t('Error').toString(),
                            autoHideDelay: 10000,
                            variant: "danger",
                            solid: true,
                            appendToast: true,
                            toaster: "b-toaster-top-center"
                        });
                    }); 
                    
			}).finally (() => {
                this.shareMode = ShareModeEnum.None;
                this.visible = false;
            });
        }

        async created(){
            console.debug("Share - created - !");
            
            /** Chargement de la liste des choix de partage */
            await this.$store.dispatch("LoadSharableItems").then(async () => {
                console.debug("Share - created - LoadSharableItems");
                this.shareMode = ShareModeEnum.Choice;

                /** Chargement des utilisateurs */
                await this.$store.dispatch("LoadUsers");
            }).catch(err => {
                console.error(err);
                this.$bvToast.toast(this.$t('SharableItemsErrorOccured').toString(), {
                    title: this.$t('Error').toString(),
                    autoHideDelay: 10000,
                    variant: "danger",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-top-center"
                });
            })
        }
    }

    /**
     * Enumération pour l'affichage des différents composants
     */
    enum ShareModeEnum {
        None = 0,
        Choice = 1,
        Component = 2,
        Users = 3
    }
</script>

<style scoped>
</style>